import React from 'react';
import { BaseButton, useCopyToast } from '@repo/common';

const OverviewRow = ({ icon, label, value, copyIcon }) => {
  const { copy, copyToast } = useCopyToast();

  return (
    <div className='flex items-start tabletH:items-center gap-1 self-stretch text-text-primary'>
      <span className='shrink-0 text-icon-primary'>{icon}</span>
      <span className='typo-b14Strong mt-0.5 shrink-0 whitespace-nowrap'>
        {label}:
      </span>
      <span className='typo-b14 mt-0.5 min-w-0 break-words'>{value}</span>
      {copyIcon && (
        <BaseButton
          type='text'
          size='s'
          onClick={() => copy(value)}
          /* 첫 줄 라인박스(14px × 140% ≈ 20px) 안에서만 세로 중앙 정렬 */
          className='mt-0.5 flex h-5 min-w-0 shrink-0 items-center self-start cursor-pointer rounded-none border-0 bg-transparent p-0 hover:bg-transparent text-icon-primary hover:text-icon-tertiary'
          aria-label={`${label} copy`}
          icon={copyIcon}
        />
      )}
      {copyToast}
    </div>
  );
};

export default OverviewRow;
